import { render, staticRenderFns } from "./LayoutTab.vue?vue&type=template&id=011eff8f&scoped=true&"
import script from "./LayoutTab.vue?vue&type=script&lang=js&"
export * from "./LayoutTab.vue?vue&type=script&lang=js&"
import style0 from "./LayoutTab.vue?vue&type=style&index=0&id=011eff8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011eff8f",
  null
  
)

export default component.exports